import { ReactNode, useEffect } from 'react';
import { Box } from '@chakra-ui/react';

const ContactView = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    const j = (nodeOrQuerySelector: any) => {
      if (typeof nodeOrQuerySelector === 'string') {
        return document.querySelector(nodeOrQuerySelector);
      }
      return nodeOrQuerySelector;
    };
    (window as any).jQuery = (window as any).jQuery || j;
  }, []);
  return (
    <Box
      height="max-content"
      width={{ base: '100%', md: '100%', lg: '80%' }}
      backgroundColor="white"
      margin="0 auto"
    >
      <Box marginX="2rem" paddingBottom="4.5rem">
        {children}
      </Box>
    </Box>
  );
};

export default ContactView;
